import { Entity, ImpactedCompany } from '@toggle/toggle';
import React from 'react';

import { useEntities } from '~/react-query-hooks/entities/useEntities';

import { PrimaryCompanyCard } from './components/company-card/PrimaryCompanyCard';
import { SecondaryCompanyCard } from './components/company-card/SecondaryCompanyCard';
import * as S from './ImpactedCompanies.styles';

export interface ImpactedCompaniesProps {
  impactedCompanies: ImpactedCompany[];
  variant?: 'primary' | 'secondary';
  title: string;
  insightCreatedAt?: string;
}

export const ImpactedCompanies = ({
  impactedCompanies,
  variant = 'primary',
  title,
  insightCreatedAt,
}: ImpactedCompaniesProps) => {
  const entityTags = impactedCompanies.map(c => c.entity_tag);
  const { data: entities, isLoading } = useEntities({
    entityTags,
    enabled: !!entityTags.length,
  });

  const companiesWithEntities = impactedCompanies.reduce((acc, company) => {
    const entity = entities?.find(e => e.tag === company.entity_tag);

    if (entity) {
      acc.push({ company, entity });
    }

    return acc;
  }, [] as { company: ImpactedCompany; entity: Entity }[]);

  if (isLoading) {
    return <S.StyledLoader />;
  }

  if (!companiesWithEntities.length) {
    return null;
  }

  return (
    <S.Root>
      <S.Title>{title}</S.Title>
      <S.CompaniesWrapper>
        {companiesWithEntities.map(company => {
          if (variant === 'primary') {
            return (
              <PrimaryCompanyCard
                key={company.company.entity_tag}
                company={company.company}
                entity={company.entity}
              />
            );
          }

          return (
            <SecondaryCompanyCard
              key={company.company.entity_tag}
              company={company.company}
              entity={company.entity}
              referenceDate={insightCreatedAt}
            />
          );
        })}
      </S.CompaniesWrapper>
    </S.Root>
  );
};
